import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_436: DocMigration = {
  maxSchemaVersion: "0.0.436",
  description: "Change default camera key to topRightPerspectiveCamera in parameter values (fix for migration 0_0_423)",
  apply(json: any) {
    const contentSourceType = "CONTENT_SOURCE";
    const view3DType = "VIEW_3D";
    const defaultExteriorCameraKey = "defaultExteriorCamera";
    const topRightPerspectiveCameraKey = "topRightPerspectiveCamera";

    function parameterIs3DViewContentSource(parameterKey: string) {
      if (
        json.localParameters[parameterKey]?.type === contentSourceType &&
        json.localParameters[parameterKey]?.viewType === view3DType
      ) {
        return true;
      }
      if (
        json.globalParameters[parameterKey]?.type === contentSourceType &&
        json.globalParameters[parameterKey]?.viewType === view3DType
      ) {
        return true;
      }
      return false;
    }

    if (json.planSetTemplateConfigs !== undefined) {
      for (const planSetTemplateConfig of Object.values(json.planSetTemplateConfigs) as any[]) {
        if (planSetTemplateConfig.parameterValues === undefined) {
          continue;
        }
        for (const parameterKey of Object.keys(planSetTemplateConfig.parameterValues) as any[]) {
          if (
            parameterIs3DViewContentSource(parameterKey) &&
            planSetTemplateConfig.parameterValues[parameterKey] === defaultExteriorCameraKey
          ) {
            planSetTemplateConfig.parameterValues[parameterKey] = topRightPerspectiveCameraKey;
          }
        }
      }
    }
    if (json.contentTemplateInstances !== undefined) {
      for (const contentTemplateInstance of Object.values(json.contentTemplateInstances) as any[]) {
        if (contentTemplateInstance.parameterValues === undefined) {
          continue;
        }
        for (const parameterKey of Object.keys(contentTemplateInstance.parameterValues) as any[]) {
          if (
            parameterIs3DViewContentSource(parameterKey) &&
            contentTemplateInstance.parameterValues[parameterKey] === defaultExteriorCameraKey
          ) {
            contentTemplateInstance.parameterValues[parameterKey] = topRightPerspectiveCameraKey;
          }
        }
      }
    }
    if (json.localParameters !== undefined) {
      for (const parameterKey of Object.keys(json.localParameters) as any[]) {
        if (
          json.localParameters[parameterKey]?.type === contentSourceType &&
          json.localParameters[parameterKey]?.viewType === view3DType &&
          json.localParameters[parameterKey]?.defaultValue === defaultExteriorCameraKey
        ) {
          json.localParameters[parameterKey].defaultValue = topRightPerspectiveCameraKey;
        }
      }
    }
    if (json.globalParameters !== undefined) {
      for (const parameterKey of Object.keys(json.globalParameters) as any[]) {
        if (
          json.globalParameters[parameterKey]?.type === contentSourceType &&
          json.globalParameters[parameterKey]?.viewType === view3DType &&
          json.globalParameters[parameterKey]?.defaultValue === defaultExteriorCameraKey
        ) {
          json.globalParameters[parameterKey].defaultValue = topRightPerspectiveCameraKey;
        }
      }
    }
    return json;
  },
};
export default migration_0_0_436;
